import { render, staticRenderFns } from "./LinkButtonsBlock.vue?vue&type=template&id=79a2502c&"
import script from "./LinkButtonsBlock.vue?vue&type=script&lang=js&"
export * from "./LinkButtonsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports